import { GET_ALL_FILES } from "services/ApiServices";
import appConfig from "../appConfig";
const SERVER_URL = appConfig.SERVER_URL;
export const API = {
  AUTH_LOGIN_SESSION_KEY: `${SERVER_URL}/certify/api/v1/auth/session-key`,
  AUTH_LOGIN: `${SERVER_URL}/certify/api/v1/auth/login`,
  AUTH_LOGOUT: `${SERVER_URL}/certify/api/v1/auth/logout`,
  TEMPLATE_PUBLISH: `${SERVER_URL}/certify/api/v1/template/vc`,
  TEMPLATE: `${SERVER_URL}/certify/api/v1/template`,
  TEMPLATE_DELETE: `${SERVER_URL}/certify/api/v1/template/delete`,
  TEMPLATE_SEARCH: `${SERVER_URL}/certify/api/v1/template/search`,
  CATEGORY: `${SERVER_URL}/certify/api/v1/category`,
  HOLDER: `${SERVER_URL}/certify/api/v1/holder`,
  VCS: `${SERVER_URL}/certify/api/v1/vcs`,
  VCS_PREPARE: `${SERVER_URL}/certify/api/v1/vcs/prepare`,
  VCS_COMPLETE: `${SERVER_URL}/certify/api/v1/vcs/complete`,

  VP: `${SERVER_URL}/certify/api/v1/vp`,
  ISSUER_DASHBOARD_SUMMARY: `${SERVER_URL}/certify/api/v1/dashboard/summary`,
  ISSUER_USERS: `${SERVER_URL}/certify/api/v1/user/chart-data`,
  ISSUER_CREDENTIALS_BY_DEPT: `${SERVER_URL}/certify/api/v1/dashboard/credentialsByDepartment`,
  ISSUER_CREDENTIALS_BY_TYPE: `${SERVER_URL}/certify/api/v1/dashboard/credentialsByType`,
  ISSUER_ANALYTICS_SUMMARY: `${SERVER_URL}/certify/api/v1/analytics/issuer/summary`,
  ISSUER_ANALYTICS_CHART: `${SERVER_URL}/certify/api/v1/analytics/issuer/chart-data`,
  ISSUER_ORGANIZATION: `${SERVER_URL}/certify/api/v1/organization`,
  VERIFIER_DASHBOARD_CHART: `${SERVER_URL}/certify/api/v1/dashboard/verifier/chart-data`,
  VERIFIER_ANALYTICS_SUMMARY: `${SERVER_URL}/certify/api/v1/analytics/verifier/summary`,
  VERIFIER_ANALYTICS_CHART: `${SERVER_URL}/certify/api/v1/analytics/verifier/chart-data`,
  ADMIN_ANALYTICS_SUMMARY: `${SERVER_URL}/certify/api/v1/analytics/admin/summary`,
  ISSUER_DASHBOARD_TABLE: `${SERVER_URL}/certify/api/v1/vcs/org`,
  DEPARTMENT: `${SERVER_URL}/certify/api/v1/department`,
  TEMPLATE_VC: `${SERVER_URL}/certify/api/v1/template/vc`,
  TEMPLATE_VP: `${SERVER_URL}/certify/api/v1/template/vpRequest`,
  VCS_REVOKE: `${SERVER_URL}/certify/api/v1/vcs/revoke`,
  VP_REQUEST: `${SERVER_URL}/certify/api/v1/vp`,
  USER: `${SERVER_URL}/certify/api/v1/user`,
  FORGOT_PASSWORD: `${SERVER_URL}/certify/api/v1/auth/forgot-password`,
  RESET_PASSWORD: `${SERVER_URL}/certify/api/v1/auth/set-password`,
  AUTH_OTP: `${SERVER_URL}/certify/api/v1/auth/otp`,
  RESEND_OTP: `${SERVER_URL}/certify/api/v1/auth/resend-otp`,
  ADMIN_USER_CHART: `${SERVER_URL}/certify/api/v1/dashboard/admin/chart-data/users`,
  USER_ADMIN: `${SERVER_URL}/certify/api/v1/user/admin`,
  ADMIN_HOLDERS_CHART: `${SERVER_URL}/certify/api/v1/dashboard/admin/chart-data/holders`,
  ADMIN_DASHBOARD_TABLE: `${SERVER_URL}/certify/api/v1/activity/admin`,
  ADMIN_WEBHOOK: `${SERVER_URL}/certify/api/v1/webhook`,
  ADMIN_WEBHOOK_TABLE: `${SERVER_URL}/certify/api/v1/webhook`,
  DAPP: `${SERVER_URL}/certify/api/v1/dapp`,
  ADMIN_DELETE_WEBHOOK: `${SERVER_URL}/certify/api/v1/webhook`,
  ADMIN_ACTIVATE_WEBHOOK: `${SERVER_URL}/certify/api/v1/webhook`,
  ADMIN_DEACTIVATE_WEBHOOK: `${SERVER_URL}/certify/api/v1/webhook`,
  DAPP_UPDATE: `${SERVER_URL}/certify/api/v1/dapp/update`,
  ORGANIZATION: `${SERVER_URL}/certify/api/v1/organization`,
  ANALYTICS_ADMIN_CHART_DATA: `${SERVER_URL}/certify/api/v1/analytics/admin/chart-data`,
  ANALYTICS_ADMIN: `${SERVER_URL}/certify/api/v1/analytics/admin`,
  USER_SUPER_ADMIN: `${SERVER_URL}/certify/api/v1/user/superAdmin`,
  SUPERADMIN_VC_CHART: `${SERVER_URL}/certify/api/v1/dashboard/superAdmin/vc`,
  SUPERADMIN_VP_CHART: `${SERVER_URL}/certify/api/v1/dashboard/superAdmin/vpRequest`,
  ANALYTICS_SUPER_ADMIN_CHART_DATA: `${SERVER_URL}/certify/api/v1/analytics/superAdmin/chart-data`,
  ANALYTICS_SUPER_ADMIN: `${SERVER_URL}/certify/api/v1/analytics/superAdmin`,
  CHECK_ORG_NAME_OR_EMAIL: `${SERVER_URL}/certify/api/v1/user/checkOrganizationNameOrEmail`,
  SUPERADMIN_ANALYTICS_SUMMARY: `${SERVER_URL}/certify/api/v1/analytics/superAdmin/summary`,
  // AUTH_KMS_DECRYPTION: `${SERVER_URL}/certify/api/v1/auth/kms-decryption`,
  // AUTH_KMS_ENCRYPTION: `${SERVER_URL}/certify/api/v1/auth/kms-encryption`,
  VP_QR: `${SERVER_URL}/certify/api/v1/vp/polling`,
  VP_VERIFY: `${SERVER_URL}/certify/api/v1/vp/verify`,
  ISSUED_BY: `${SERVER_URL}/certify/api/v1/organization/all`,
  ORGANIZATION_TEMPLATE: `${SERVER_URL}/certify/api/v1/template/organizations`,
  ISSUER: `${SERVER_URL}/certify/api/v1/analytics/issuer`,

  CREATE_DID_REQUEST: `${SERVER_URL}/certify/api/v1/did/initiate`,
  SUBMIT_DID_REQUEST: `${SERVER_URL}/certify/api/v1/did/submit`,

  HOLDER_SHARED_CREDENTIALS: `${SERVER_URL}/certify/api/v1/holder/shared-credentials`,
  VERIFY_CREDENTIAL: `${SERVER_URL}/certify/api/v1/vcs/verify`,

  //Certificate
  GET_ALL_ASSETS: `${SERVER_URL}/certify/api/v1/visual-designs/assets`,
  UPLOAD_ASSETS: `${SERVER_URL}/certify/api/v1/visual-designs/assets`,
  GET_ALL_VARIABLES: `${SERVER_URL}/certify/api/v1/visual-designs/assets/variables`,
  SAVE_DESIGNS: `${SERVER_URL}/certify/api/v1/visual-designs`,

  TOKEN_VERIFICATION: `${SERVER_URL}/certify/api/v1/vcs/verify-token`,

  GET_PUBLICKEY: `${SERVER_URL}/certify/api/v1/user/did-public-key`,

  HOLDER_ONBOARDING: `${SERVER_URL}/certify/api/v1/organization/holders`,
  HOLDER_ONBOARDING_RESEND: `${SERVER_URL}/certify/api/v1/user/deep-link`,

  POW_UPLOAD: `${SERVER_URL}/certify/api/v1/pow/upload-zip`,
  GET_ALL_FILES: `${SERVER_URL}/certify/api/v1/pow/holders/files`,

  GET_ALL_FILES_BY_ID: `${SERVER_URL}/certify/api/v1/pow`,
};
